export default __webpack_public_path__ + "static/media/gerbera.b9a10a82.png";